import React, { useEffect } from "react";
import { View, Dimensions } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import colors from "@constants/color";
import { getWalletSummaryV3 } from "@services/api";
import { actions as walletV3Actions } from '@reducers/walletV3Reducer';
import t from "@constants/localization";
import Text from "@components/CustomText";
import BackButton from "@components/BackButton";
import WalletBackground from "@assets/svg/Wallet/WalletBackground";
import MaskgroupTop from "@assets/svg/Wallet/MaskgroupTop";
import MaskgroupBottom from "@assets/svg/Wallet/MaskgroupBottom";
import { fonts } from "@constants/metrics";
import { ScaledSheet } from '@utils/scale';

const WithdrawGullakMoneyHeader = ({ 
  navigation, 
  route,
  headerColor = "#fff",
  hideShadow = false,
  isTransparent = false,
  goingBackHandler,
  alwaysEnable = false,
}) => {
  const PATH = "screens/WithDrawGullakMoney/index";
  const dispatch = useDispatch();

  const summary = useSelector((state) => state.walletV3Reducer?.walletSummary);
  

  useEffect(() => {
    if (!summary) {
      fetchData();
    }
  }, [dispatch, summary]);

  const fetchData = async () => {
    dispatch(walletV3Actions.setWalletV3Loading(true));
    try {
      const { data } = await getWalletSummaryV3();
      dispatch(walletV3Actions.getWalletV3SummarySuccess(data?.summary));
    } catch (error) {
      console.log(error);
      dispatch(walletV3Actions.getWalletV3SummaryFail(error));
    } finally {
      dispatch(walletV3Actions.setWalletV3Loading(false));
    }
  };

  // Get screen dimensions for responsive design
  const { width: screenWidth } = Dimensions.get('window');
  
  // Calculate responsive sizes for decorative circles (based on 375px design width)
  const scale = screenWidth / 375;
  const maskTopWidth = Math.round(144 * scale);
  const maskTopHeight = Math.round(101 * scale);
  const maskBottomWidth = Math.round(102 * scale);
  const maskBottomHeight = Math.round(138 * scale);

  return (
    <View style={styles.headerContainer}>
      {/* Background Image */}
      <View style={styles.backgroundContainer}>
        <WalletBackground width={screenWidth} height={260} preserveAspectRatio="xMidYMid slice" />
      </View>

      {/* Decorative circles in top right */}
      <View style={styles.decorativeCirclesContainer}>
        <View style={styles.maskgroupTop}>
          <MaskgroupTop width={maskTopWidth} height={maskTopHeight} />
        </View>
        <View style={styles.maskgroupBottom}>
          <MaskgroupBottom width={maskBottomWidth} height={maskBottomHeight} />
        </View>
      </View>

      {/* Content */}
      <View style={styles.contentContainer}>
        <View style={styles.headerContent}>
          <BackButton
            onPress={goingBackHandler ?? navigation.goBack}
            alwaysEnable={alwaysEnable}
            tintColor={colors.white}
          />
          <View style={styles.titleContainer}>
            <Text
              style={{
                fontSize: fonts.head1,
                fontWeight: '700',
                color: colors.white,
              }}
            >
              {'Withdraw'}
            </Text>
          </View>
        </View>
        <View style={styles.balanceContainer}>
          <Text style={styles.balanceLabel}>Your Balance</Text>
          <Text style={styles.balanceAmount}>
            {summary?.value_txt}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = ScaledSheet.create({
  headerContainer: {
    position: 'relative',
    overflow: 'hidden',
  },
  backgroundContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  decorativeCirclesContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 0,
  },
  maskgroupTop: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  maskgroupBottom: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  contentContainer: {
    paddingTop: 16,
    paddingBottom: 48,
    paddingHorizontal: 12,
    zIndex: 1,
  },
  headerContent: {
    flexDirection: "row",
    marginBottom: 24,
  },
  titleContainer: {
    flex: 1,
    marginLeft: 10,
    justifyContent: "center",
  },
  balanceContainer: {
    alignItems: "center",
    paddingVertical: 16,
  },
  balanceLabel: {
    fontSize: 16,
    color: colors.white,
    marginBottom: 8,
    fontWeight: "400",
  },
  balanceAmount: {
    fontSize: 48,
    color: colors.white,
    fontWeight: "700",
    letterSpacing: 1,
  },
  cardContainer: {
    marginTop: 20,
  },
});

export default WithdrawGullakMoneyHeader;
